import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { IItemWishList } from 'src/app/shared/interfaces/custom-item-wish-list';
import { WishList } from 'src/app/utils/functions/wishList';
import {
  trigger,
  transition,
  style,
  animate
} from '@angular/animations';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { IState } from 'src/app/platform/users/interfaces/state.interface';
import { UsersService } from 'src/app/platform/users/services/users.service';
import { ICity } from 'src/app/platform/users/interfaces/city.interface';
import { NotifictChangeListService } from '../../services/notifict-change-list.service';
import constants from 'src/config/constants';

@Component({
  selector: 'confirm-direction-modal',
  templateUrl: './confirm-direction-modal.component.html',
  providers: [MessageService],
  animations: [
    trigger('fadeSlide', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-10px)' }),
        animate('250ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0, transform: 'translateY(-10px)' }))
      ])
    ])
  ]
})
export class ConfirmDirectionModalComponent implements OnChanges, OnInit, OnDestroy {

  @Input() visible: boolean = false;
  @Input() address!: string;
  @Input() city!: string;
  @Output() noVisible = new EventEmitter<boolean>();

  item: IItemWishList = new IItemWishList();
  numItem: number = 0;
  totPriceWishList: number = 0;
  newDirectionForm!: FormGroup;
  editDirection: boolean = false;
  formSubscription?: Subscription;
  stateSelected?: IState;
  citySelected?: ICity;
  cities: ICity[] = [];
  states: IState[] = [];
  validateAddress: RegExp = constants.validateAddress;
  isLoading: boolean = true;
  cantItemsCop:number = 0;

  constructor(
    private wishList: WishList,
    public readonly messageService: MessageService,
    private readonly fb: FormBuilder,
    private _router: Router,
    private _userService: UsersService,
    private notificChangeListService: NotifictChangeListService
  ) {}

  editButtonCssOptions = {
    width: '30px', height: '30px',
    margin: 'auto 10px', display: 'flex',
    justifyContent: 'center', alignItems: 'center',
    backgroundColor: 'var(--secondary-color)',
    borderRadius: '50%', color: 'white',
    cursor: 'pointer'
  }

  ngOnInit(): void {
    const localData = localStorage.getItem('user');
    this.cantItemsCop = this.wishList.countForItems();

    this.newDirectionForm = this.fb.group({
      address : [this.address, []],
      newAddress: ['', [Validators.required, Validators.minLength(5), Validators.pattern(this.validateAddress)]],
      city: [this.citySelected, [Validators.required]],
      state: [this.stateSelected, [Validators.required]]
    })
    this.numItem = this.wishList.countForItems();
    this.totPriceWishList = this.wishList.totPriceWishList();
    if(localData){
      this._userService.getStates().subscribe({
        next: (response) => {
          this.states = response.data;
        }
      });

      this._userService.getCitiesSameState(this.city!).subscribe({
        next: (response) => {
          this.stateSelected = this.states.find((state) => state.id == response.data.state);
          this.cities = response.data.cities;
          this.newDirectionForm.controls['state'].setValue(this.stateSelected);
          this.citySelected = this.cities.find((city) => city.id == this.city);
          this.newDirectionForm.controls['city'].setValue(this.citySelected);
        },
        error: (err)=> {
          console.debug(err);
          throw err;
        }
      });
    }

    this.formSubscription = this.newDirectionForm.controls['state'].valueChanges.subscribe(change => {
      this._userService.getCities(change?.id).subscribe({
        next: (resp)=> {
          if(this.stateSelected?.id !== this.newDirectionForm.value.state?.id){
            this.newDirectionForm.controls['city'].setValue({});
          }
          this.cities = resp.data;
        },
        error: (err)=> {
          console.debug(err);
          throw err;
        }
      })
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.numItem = this.wishList.countForItems();
    this.totPriceWishList = this.wishList.totPriceWishList();
  }

  ngOnDestroy(): void {
    this.formSubscription?.unsubscribe();
    this.newDirectionForm.reset();
  }


  showDialog() {
    this.visible = true;
  }

  cancelar(){
    this.editDirection = false;
    this.noVisible.emit(false);
    if(localStorage.getItem('goToOrder')){
      localStorage.removeItem('goToOrder');
    }
  }

  showEditDirection(){
    this.editDirection = !this.editDirection;
  }

  deleteMakeOrderLocalStorage(){
    this.visible = false;
    this.editDirection = false;
    this.noVisible.emit(this.visible);

    if(localStorage.getItem('goToOrder')){
      localStorage.removeItem('goToOrder');
    }

    if(this.newDirectionForm.get('newAddress')?.value === undefined || this.newDirectionForm.get('newAddress')?.value.trim() === ''){
      this._router.navigate(['/new-order']);
    } else {
      this._router.navigate(['/new-order'], {
        queryParams: {newAddress: encodeURIComponent(this.newDirectionForm.get('newAddress')?.value), newCity: encodeURIComponent(this.newDirectionForm.get('city')?.value.id)}
      });
    }
  }

  changeOfList() {
    this.isLoading = true;
    this.cantItemsCop = this.wishList.countForItems();
    if(this.cantItemsCop === 0){
      this.visible = false;
    }
    this.notificChangeListService.notificationUpdate(this.cantItemsCop);
    this.isLoading = false;
  }
}
